<div class="p-6">
  <div class="flex justify-between items-center mb-6">
    <h2 class="text-2xl font-semibold">Gestión de Accesos — Canal Denuncias</h2>
    <button mat-raised-button color="primary" (click)="addOperator()">
      <mat-icon>person_add</mat-icon> Agregar operador
    </button>
  </div>

  <div *ngIf="loading" class="flex justify-center py-8">
    <mat-spinner diameter="40"></mat-spinner>
  </div>

  <div class="bg-white rounded-2xl shadow-md" *ngIf="!loading">
    <table mat-table [dataSource]="dataSource" class="w-full">

      <ng-container matColumnDef="operatorName">
        <th mat-header-cell *matHeaderCellDef>Nombre</th>
        <td mat-cell *matCellDef="let op">{{ op.operatorName }}</td>
      </ng-container>

      <ng-container matColumnDef="operatorEmail">
        <th mat-header-cell *matHeaderCellDef>Email</th>
        <td mat-cell *matCellDef="let op">{{ op.operatorEmail }}</td>
      </ng-container>

      <ng-container matColumnDef="role">
        <th mat-header-cell *matHeaderCellDef>Rol</th>
        <td mat-cell *matCellDef="let op">
          <mat-select [value]="op.role" (selectionChange)="changeRole(op, $event.value)">
            <mat-option *ngFor="let r of roles" [value]="r">{{ r }}</mat-option>
          </mat-select>
        </td>
      </ng-container>

      <ng-container matColumnDef="isActive">
        <th mat-header-cell *matHeaderCellDef>Estado</th>
        <td mat-cell *matCellDef="let op">
          <span *ngIf="op.isActive" class="px-2 py-1 rounded-full text-xs bg-green-100 text-green-800">Activo</span>
          <span *ngIf="!op.isActive" class="px-2 py-1 rounded-full text-xs bg-red-100 text-red-800">Inactivo</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Acciones</th>
        <td mat-cell *matCellDef="let op">
          <button mat-icon-button color="warn" (click)="revokeAccess(op)"
                  matTooltip="Revocar acceso"
                  [disabled]="!op.isActive">
            <mat-icon>block</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell text-center py-8" [attr.colspan]="displayedColumns.length">
          No hay operadores registrados
        </td>
      </tr>
    </table>
  </div>
</div>
